import { colors } from "@/Utils/Variables";
import { styled } from "@mui/material";

export const ToolTipContainer = styled("div")(({ theme }) => {
  return {
    backgroundColor: theme.palette.mode === "dark" ? colors.cardBg : "#FFF",
    padding: "1.25rem",
    gap: "0.75rem",
  };
});
